@import "tailwindcss";

@layer base {
  :root {
    /* Webflow colors - Light Mode */
    --background1: #FFFFFF;
    --background2: #F9FAFB;
    --background3: #F3F4F6;
    --background4: #E5E7EB;
    --background5: #D1D5DB;
    --backgroundInactive: #F3F4F6;
    --backgroundInverse: #111827;
    --backgroundInput: rgba(0, 0, 0, 0.04);

    --actionPrimaryBackground: #2563EB;
    --actionPrimaryBackgroundHover: #1D4ED8;
    --actionSecondaryBackground: linear-gradient(180deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.05) 100%);
    --actionSecondaryBackgroundHover: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.08) 100%);
    --actionPrimaryText: #FFFFFF;
    --actionPrimaryTextHover: #FFFFFF;
    --actionSecondaryText: #374151;
    --actionSecondaryTextHover: #111827;

    --border1: #E5E7EB;
    --border2: #D1D5DB;
    --border3: #9CA3AF;

    --text1: #111827;
    --text2: #4B5563;
    --text3: #6B7280;
    --textInactive: #9CA3AF;
    --textInverse: #FFFFFF;

    --blueText: #2563EB;
    --blueIcon: #2563EB;
    --blueBorder: #2563EB;

    --greenBackground: #10B981;
    --greenBackgroundHover: #059669;
    --greenText: #FFFFFF;
    --greenIcon: #10B981;
    --greenBorder: #10B981;

    --yellowBackground: #F59E0B;
    --yellowBackgroundHover: #D97706;
    --yellowText: #FFFFFF;
    --yellowIcon: #F59E0B;
    --yellowBorder: #F59E0B;

    --redBackground: #EF4444;
    --redBackgroundHover: #DC2626;
    --redText: #FFFFFF;
    --redIcon: #EF4444;
    --redBorder: #EF4444;

    --orangeBackground: #F97316;
    --orangeBackgroundHover: #EA580C;
    --orangeText: #FFFFFF;
    --orangeIcon: #F97316;
    --orangeBorder: #F97316;

    --purpleBackground: #8B5CF6;
    --purpleBackgroundHover: #7C3AED;
    --purpleText: #FFFFFF;
    --purpleIcon: #8B5CF6;
    --purpleBorder: #8B5CF6;

    /* Box shadows for buttons and inputs */
    --boxShadows-action-colored: 0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset;
    --boxShadows-action-secondary: 0px 1px 2px rgba(0, 0, 0, 0.05), inset 0px 1px 0px rgba(255, 255, 255, 0.5);
    --boxShadows-input-inner: 0px 1px 2px -1px rgba(0, 0, 0, 0.05) inset, 0px 2px 4px -2px rgba(0, 0, 0, 0.05) inset;

    --boxShadows-menu: 0px 12px 24px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px 2px rgba(0, 0, 0, 0.04), 0px 2px 6px 0px rgba(0, 0, 0, 0.04), 0px 0px 1px 0px rgba(0, 0, 0, 0.1);

    --input-inner-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.05) inset, 0px 2px 4px -2px rgba(0, 0, 0, 0.05) inset;

    --menu-shadow: 0px 12px 24px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px 2px rgba(0, 0, 0, 0.04), 0px 2px 6px 0px rgba(0, 0, 0, 0.04), 0px 0px 1px 0px rgba(0, 0, 0, 0.1);

    /* TYPOGRAPHY */
    --font-stack: 'Inter', sans-serif;
    --font-size-small: 11.5px;
    --font-size-small-letter-spacing: -0.115px;
    --font-size-large: 12.5px;
    --font-weight-normal: 400;
    --font-weight-medium: 600;
    --border-radius: 4px;
  }
  body {
    @apply bg-[var(--background1)] text-[var(--text1)] text-[13px] antialiased m-0 p-0 overflow-x-hidden;
    font-family: var(--font-stack);
  }
  button, a {
    @apply cursor-pointer;
  }
  button:disabled {
    @apply cursor-not-allowed;
  }
}

@layer utilities {
  .animate-slide-in-right {
    animation: slide-in-right 0.3s ease-out forwards;
  }
}

@keyframes slide-in-right {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
